import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';

import { Device } from '../device.model';
import { DeviceService } from '../device.service';

import { UserService } from '../../user/user.service';

import { Organization } from '../../organization/organization.model';
import { OrganizationService } from '../../organization/organization.service';

import { Location } from '../../locations/location.model';
import { LocationService } from '../../locations/location.service';

import { LocationOrgFilterPipe } from '../../shared/location-org-filter.pipe';

@Component({
  selector: 'app-device-edit',
  templateUrl: './device-edit.component.html',
  styleUrls: ['./device-edit.component.scss']
})
export class DeviceEditComponent implements OnInit {

  public deviceId: number;
  public device: Device;

  public defaultDevice = {
    id                  : 0,
    code                : '',
    name                : '',
    org_id              : 0,
    location_id         : 0,
    vpn_port            : '',
    vpn_ip              : '',
    subnet_mask         : '255.255.255.0',
    hologram_device_id  : '',
    online              : false,
    remote              : true,
    disabled_for_ordinary_users : false,
    cell_org_id         : 0,
    cell_state          : '',
    cell_limit          : 0,
    cell_usage          : 0,
    mssfix              : true,

    connection_type     : '',
    rssi_value          : 0,

    status              : '',
    editing             : false,
    selected            : false,
    connection_status   : 'disconnected',
    ui_state            : '',

    // Children
    connections         : [],
    ports               : null
  }

  constructor(
    public router: Router,
    public activatedRoute: ActivatedRoute,
    public deviceService: DeviceService,
    public userService: UserService,
    public organizationService: OrganizationService,
    public locationService: LocationService
  ) { }

  ngOnInit(): void {
    console.log(this);
    this.activatedRoute.params.subscribe((params) => {
      if (params.device_id) {
        this.deviceId = params.device_id;
        this.device = this.deviceService.device(this.deviceId);
        if (!this.device) this.router.navigate(['../devices']);
      } else {
        this.device = new Device(this.defaultDevice);
        this.device.org_id = this.userService.userInfo.group.id;
      }
    })
  }

  submitForm() {
    let deviceSub;
    if (this.device.id === 0) {
      deviceSub = this.deviceService.createDevice(this.device);
    } else {
      deviceSub = this.deviceService.saveDevice(this.device)
    }
    console.log(deviceSub, this.device);
    deviceSub.subscribe((res) => {
      this.router.navigate(['../devices/'+this.deviceId]);
    });
  }

}
